import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';
import { FrankaturService } from '../../api';

export const getFrankaturen =
  (mandantId: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new FrankaturService().getFrankaturen(mandantId).then(result => {
      dispatch({
        type: ActionTypes.GET_FRANKATUREN,
        payload: result.data,
      });
    });
  };
